function setVhUnit() {
  let vh = window.innerHeight * 0.01;

  document.documentElement.style.setProperty("--vh", `${vh}px`);

  // We listen to the resize event
  window.addEventListener("resize", () => {
    vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  });
}

function userMenu() {
  const userAccountBtn = document.querySelector(
    ".user-account-block .toggle-button"
  );

  const userMenu = document.querySelector(
    ".user-account-block .user-account-menu"
  );

  if (!userAccountBtn || !userMenu) return;

  userAccountBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    userMenu.classList.toggle("active");
    userAccountBtn.classList.toggle("active");
  });

  document.addEventListener("click", (e) => {
    if (!userMenu.contains(e.target) && e.target !== userAccountBtn) {
      userMenu.classList.remove("active");
      userAccountBtn.classList.remove("active");
    }
  });

  const registerLink = userMenu.querySelector('a[href="/user/register"]');

  if (registerLink) {
    registerLink.parentElement.remove();
  }
}

function handleMainMenu() {
  const breakpoint = window.matchMedia("(max-width: 1279px)");
  const btnHamburger = document.querySelector("#btn-hamburger");
  const mainMenu = document.querySelector("#navbar-mobile");
  const btnToggleSearch = document.querySelector("#btn-search-toggle");
  const searchForm = document.querySelector(
    ".main-navigation .search-block-form"
  );
  const btnUserMenu = document.querySelector("#btn-user-menu");
  const mobileUserMenu = document.querySelector(".user-account-block");
  const btnClose = document.querySelector("#btn-close-menu");

  const topMenuMobile = document.querySelector(
    "#navbar-mobile .menu--top-menu"
  );
  const authButtonsEl = document.querySelector("#auth-buttons");

  if (topMenuMobile) {
    const socialLinks = topMenuMobile.querySelectorAll(
      ".facebook, .twitter, .linkedin"
    );

    if (socialLinks.length > 0) {
      const socialMenu = document.createElement("ul");
      socialMenu.classList.add('social-menu')
  
      socialLinks.forEach((el) => {
        socialMenu.appendChild(el.parentElement);
      });
  
      topMenuMobile.appendChild(socialMenu);
    }

   
  }

  if (authButtonsEl) {
    const authLinks = document.querySelector('body:not(.user-logged-in) .main-navigation .user-account-menu .menu');

    if (authLinks) {
        authButtonsEl.appendChild(authLinks.cloneNode(true));
    }
  }

  if (btnToggleSearch && searchForm) {
    const searchInput = searchForm.querySelector('input[type="search"]');
    searchInput.setAttribute("placeholder", "What are you looking for?");
    btnToggleSearch.addEventListener("click", () => {
      searchForm.classList.add("active");
      document.body.classList.add("menu-open");
      searchInput.focus();
    });
  }

  if (btnHamburger && mainMenu) {
    btnHamburger.addEventListener("click", () => {
      mainMenu.classList.add("active");
      document.body.classList.add("menu-open");
    });
  }

  if (btnUserMenu && mobileUserMenu) {
    btnUserMenu.addEventListener("click", () => {
      mobileUserMenu.classList.add("active");
      document.body.classList.add("menu-open");
    });
  }

  function reset() {
    if (searchForm) {
      searchForm.classList.remove("active");
    }

    if (mainMenu) {
      mainMenu.classList.remove("active");
    }

    if (mobileUserMenu) {
      mobileUserMenu.classList.remove("active");
    }

    document.body.classList.remove("menu-open");
  }

  btnClose.addEventListener("click", () => {
    reset();
  });

  breakpoint.addEventListener("change", () => {
    reset();
  });
}

function handleSearchBlock() {
  const btnSearch = document.querySelector(".btn-search");
  const searchBlock = document.querySelector(".search-block-wrapper");
  const searchInput = document.querySelector(
    ".search-block-form form input.form-search"
  );
  const mainMenu = document.querySelector(".navigation.menu--main");
  const btnClose = document.querySelector(
    ".search-block-form .btn-close-search"
  );
  const breakpoint = window.matchMedia("(max-width: 1279px)");

  if (!btnSearch || !searchBlock) return;

  function reset() {
    searchBlock.classList.remove("active");

    btnSearch.classList.remove("is-hidden");
    if (mainMenu) mainMenu.classList.remove("is-hidden");
  }

  btnSearch.addEventListener("click", (e) => {
    e.stopPropagation();
    searchBlock.classList.add("active");
    searchInput.focus();
    btnSearch.classList.add("is-hidden");

    if (breakpoint.matches) {
      logo.classList.add("is-hidden");
      hamburger.classList.add("is-hidden");
    } else {
      if (mainMenu) mainMenu.classList.add("is-hidden");
    }
  });

  if (btnClose) {
    btnClose.addEventListener("click", () => {
      reset();
    });
  }

  breakpoint.addEventListener("change", () => {
    reset();
  });

  searchBlock.addEventListener("click", (e) => {
    e.stopPropagation();
  });

  window.addEventListener("click", (e) => {
    if (!e.target.isEqualNode(searchBlock)) {
      reset();
    }
  });
}

window.addEventListener("DOMContentLoaded", () => {
  setVhUnit();
  handleMainMenu();
  userMenu();
  handleSearchBlock();
});
